import React from 'react';

const Spinner = ({ altText = '' }) => (
  <div
    className='loading-spinner'
    role='alert'
    aria-live='assertive'
  >
    <p className='hidden'>{ altText }</p>
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
  </div>
);

export default Spinner;
